import React, { forwardRef } from 'react';

import { StyledAffix, StyledInput, StyledWrapper } from './TextInput.styles';
import { TTextInputProps } from './TextInput.types';

const TextInput = forwardRef<HTMLInputElement, TTextInputProps>(
  ({ prefix, suffix, className, label, ...props }, ref) => (
    <StyledWrapper className={className}>
      {prefix ? <StyledAffix>{prefix}</StyledAffix> : null}
      <StyledInput ref={ref} aria-label={label} {...props} />
      {suffix ? <StyledAffix>{suffix}</StyledAffix> : null}
    </StyledWrapper>
  )
);

TextInput.displayName = 'TextInput';

export default TextInput;
